import React from 'react'
import DailySignUpTrend from './DailySignUpTrend'
import WeeklySignUpTrend from './WeeklySignUpTrend'
import MonthlySignUpTrend from './MonthlySignUpTrend'
import { Box } from '@mui/material'

const RealtimeTrendCharts = () => {
  return (
	<Box sx={{display:"flex", flexDirection:'column', gap:2}}>
	   <DailySignUpTrend />
      <WeeklySignUpTrend />
      <MonthlySignUpTrend />
	</Box>
  )
}

export default RealtimeTrendCharts
